import React, { useEffect, useRef, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import SearchSupplier from '../../components/SearchSupplier';
import axios from 'axios';
import { dateFormat, endpointApi } from '../../utils';
import { setLoading } from '../../redux/actions/loader.action';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getRambos, updateElementInList } from '../../redux/actions/rambo.action';
import Paginate from '../../components/Paginate';
import { logout } from '../../redux/actions/auth.action';

export default function RambosPage() {
    const jwt_access = localStorage.getItem('jwt_access');
    const rambos = useSelector(state => state.rambos);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const addModal = useRef(null);
    const verificationModal = useRef(null);
    const paymentModal = useRef(null);
    const updateModal = useRef(null);
    const detailsModal = useRef(null);

    const [actionModal, setActionModal] = useState(null);
    const [modal, setModal] = useState(null);
    const [rambo, setRambo] = useState(null);
    
    const [supplier, setSupplier] = useState(null);
    const [code, setCode] = useState('');
    const [receptionDate, setReceptionDate] = useState('');
    const [origin, setOrigin] = useState('');
    const [numberOfCartons, setNumberOfCartons] = useState('');
    const [transportCost, setTransportCost] = useState('');
    const [receivedQuantityShort, setReceivedQuantityShort] = useState('');
    const [receivedQuantityLong, setReceivedQuantityLong] = useState('');
    const [receivedAfterCountingShort, setReceivedAfterCountingShort] = useState('');
    const [receivedAfterCountingLong, setReceivedAfterCountingLong] = useState('');
    const [missingQuantityShort, setMissingQuantityShort] = useState('');
    const [missingQuantityLong, setMissingQuantityLong] = useState('');
    const [unitPrice, setUnitPrice] = useState('');
    const [remainingAmount, setRemainingAmount] = useState('');
    const [sortingDate, setSortingDate] = useState('');
    const [quantityAfterSortingShort, setQuantityAfterSortingShort] = useState('');
    const [quantityAfterSortingLong, setQuantityAfterSortingLong] = useState('');
    const [wasteQuantityAfterSortingShort, setWasteQuantityAfterSortingShort] = useState('');
    const [wasteQuantityAfterSortingLong, setWasteQuantityAfterSortingLong] = useState('');
    const [paymentDate, setPaymentDate] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('');
    const [paymentReference, setPaymentReference] = useState('');
    const [paymentAccountNumber, setPaymentAccountNumber] = useState('');
    // const [description, setDescription] = useState('');
    
    const [isReceptionDateTouched, setIsReceptionDateTouched] = useState(false);
    const [isOriginTouched, setIsOriginTouched] = useState(false);
    const [isNumberOfCartonsTouched, setIsNumberOfCartonsTouched] = useState(false);
    const [isTransportCostTouched, setIsTransportCostTouched] = useState(false);
    const [isReceivedAfterCountingShortTouched, setIsReceivedAfterCountingShortTouched] = useState(false);
    const [isReceivedAfterCountingLongTouched, setIsReceivedAfterCountingLongTouched] = useState(false);
    const [isMissingQuantityShortTouched, setIsMissingQuantityShortTouched] = useState(false);
    const [isMissingQuantityLongTouched, setIsMissingQuantityLongTouched] = useState(false);
    const [isQuantityAfterSortingShortTouched, setIsQuantityAfterSortingShortTouched] = useState(false);
    const [isQuantityAfterSortingLongTouched, setIsQuantityAfterSortingLongTouched] = useState(false);
    const [isSortingDateTouched, setIsSortingDateTouched] = useState(false);
    const [isWasteQuantityAfterSortingShortTouched, setIsWasteQuantityAfterSortingShortTouched] = useState(false);
    const [isWasteQuantityAfterSortingLongTouched, setIsWasteQuantityAfterSortingLongTouched] = useState(false);
    const [isUnitPriceTouched, setIsUnitPriceTouched] = useState(false);
    const [isPaymentDateTouched, setIsPaymentDateTouched] = useState(false);
    const [isPaymentMethodTouched, setIsPaymentMethodTouched] = useState(false);
    const [isCodeTouched, setIsCodeTouched] = useState(false);
    
    const [errors, setErrors] = useState(null);

    useEffect(() => {
        const clickModalOutside = (e) => {
            if((addModal.current && addModal.current === e.target && addModal.current.classList.contains('active')) || (verificationModal.current && verificationModal.current === e.target && verificationModal.current.classList.contains('active')) || (paymentModal.current && paymentModal.current === e.target && paymentModal.current.classList.contains('active')) || (updateModal.current && updateModal.current === e.target && updateModal.current.classList.contains('active')) || (detailsModal.current && detailsModal.current === e.target && detailsModal.current.classList.contains('active')) || e.target.classList.contains('_modal-close')){
                setModal(null);
            }
        }
        document.addEventListener('click', clickModalOutside);
        return () => {
            document.removeEventListener('click', clickModalOutside);
        }
    }, []);

    useEffect(() => {
        dispatch(getRambos(location, navigate));
    }, [location, dispatch, navigate]);

    useEffect(() => {
        if(unitPrice !== '' && quantityAfterSortingShort !== '' && quantityAfterSortingLong !== '' && unitPrice !== null && quantityAfterSortingShort !== null && quantityAfterSortingLong !== null){
          setRemainingAmount(unitPrice * (quantityAfterSortingLong + quantityAfterSortingShort));
        }else{
          setRemainingAmount("");
        }
    }, [unitPrice, quantityAfterSortingLong, quantityAfterSortingShort]);

    useEffect(() => {
        if(rambo && (modal === "update" || modal === "verification" || modal === "payment")){
            // réception
            setCode(rambo.code !== null ? rambo.code : '');
            setSupplier(rambo.supplier !== null ? rambo.supplier : '');
            setReceptionDate(rambo.reception_date !== null ? rambo.reception_date : '');
            setOrigin(rambo.origin !== null ? rambo.origin : '');
            setReceivedQuantityShort(rambo.received_quantity_short !== null ? rambo.received_quantity_short : '');
            setReceivedQuantityLong(rambo.received_quantity_long !== null ? rambo.received_quantity_long : '');
            setNumberOfCartons(rambo.number_of_cartons !== null ? rambo.number_of_cartons : '');
            setTransportCost(rambo.transport_cost !== null ? rambo.transport_cost : '');
            // vérification
            setReceivedAfterCountingShort(rambo.received_after_counting_short !== null ? rambo.received_after_counting_short : '');
            setReceivedAfterCountingLong(rambo.received_after_counting_long !== null ? rambo.received_after_counting_long : '');
            setMissingQuantityShort(rambo.missing_quantity_short !== null ? rambo.missing_quantity_short : '');
            setMissingQuantityLong(rambo.missing_quantity_long !== null ? rambo.missing_quantity_long : '');
            // triage
            setSortingDate(rambo.sorting_date !== null ? rambo.sorting_date : '');
            setQuantityAfterSortingShort(rambo.quantity_after_sorting_short !== null ? rambo.quantity_after_sorting_short : '');
            setQuantityAfterSortingLong(rambo.quantity_after_sorting_long !== null ? rambo.quantity_after_sorting_long : '');
            setWasteQuantityAfterSortingShort(rambo.waste_after_sorting_short !== null ? rambo.waste_after_sorting_short : '');
            setWasteQuantityAfterSortingLong(rambo.waste_after_sorting_long !== null ? rambo.waste_after_sorting_long : '');
            // paiement
            setUnitPrice(rambo.unit_price !== null ? rambo.unit_price : '');
            setRemainingAmount(rambo.remaining_amount !== null ? rambo.remaining_amount : '');
            setPaymentDate(rambo.payment_date !== null ? rambo.payment_date : '');
            setPaymentMethod(rambo.payment_method !== null ? rambo.payment_method : '');
            setPaymentAccountNumber(rambo.payment_account_number !== null ? rambo.payment_account_number : '');
            setPaymentReference(rambo.payment_reference !== null ? rambo.payment_reference : '');
        }
    }, [rambo, modal]);

    useEffect(() => {
        if(modal === null){
            setCode('');
            setSupplier(null);
            setReceptionDate('');
            setOrigin('');
            setReceivedQuantityShort('');
            setReceivedQuantityLong('');
            setNumberOfCartons('');
            setTransportCost('');
            setReceivedAfterCountingShort('');
            setReceivedAfterCountingLong('');
            setMissingQuantityShort('');
            setMissingQuantityLong('');
            setSortingDate('');
            setQuantityAfterSortingShort('');
            setQuantityAfterSortingLong('');
            setWasteQuantityAfterSortingShort('');
            setWasteQuantityAfterSortingLong('');
            setUnitPrice('');
            setRemainingAmount('');
            setPaymentDate('');
            setPaymentMethod('');
            setPaymentAccountNumber('');
            setPaymentReference('');

            setIsReceptionDateTouched(false);
            setIsOriginTouched(false);
            setIsNumberOfCartonsTouched(false);
            setIsTransportCostTouched(false);
            setIsReceivedAfterCountingShortTouched(false);
            setIsReceivedAfterCountingLongTouched(false);
            setIsMissingQuantityShortTouched(false);
            setIsMissingQuantityLongTouched(false);
            setIsQuantityAfterSortingShortTouched(false);
            setIsQuantityAfterSortingLongTouched(false);
            setIsSortingDateTouched(false);
            setIsWasteQuantityAfterSortingShortTouched(false);
            setIsWasteQuantityAfterSortingLongTouched(false);
            setIsUnitPriceTouched(false);
            setIsPaymentDateTouched(false);
            setIsPaymentMethodTouched(false);
            setIsCodeTouched(false);
        }
        if(modal){
            const $modals = document.querySelectorAll('._modal-content');
            $modals.forEach($modal => {
                $modal.scrollTop = 0;
            })
        }
    }, [modal]);

    useEffect(() => {
        const clickOutsideActionModal = (e) => {
            const $actionModals = document.querySelectorAll('.actions>ul');
            $actionModals.forEach($actionModal => {
                if($actionModal && !$actionModal.contains(e.target) && $actionModal.classList.contains('active')){
                    setActionModal(null);
                }
            });
        }
        document.addEventListener('click', clickOutsideActionModal);
        return () => {
            document.removeEventListener('click', clickOutsideActionModal);
        }
    }, []);

    const handleAddRambo = async (e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);
        
        await axios.post(`${ endpointApi }rambos`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${ jwt_access }`      
                        }
                    })
                    .then(({ data }) => {
                        dispatch(getRambos(location, navigate));
                        setRambo(data);
                        setModal("details");
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                            const $modals = document.querySelectorAll('._modal-content');
                            $modals.forEach($modal => {
                                $modal.scrollTop = 0;
                            });
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }
    
    const handleVerificationRambo = async (e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);
        
        await axios.put(`${ endpointApi }rambos/${ rambo?.id }/verification`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${ jwt_access }`      
                        }
                    })
                    .then(({ data }) => {
                        dispatch(updateElementInList(data));
                        setRambo(data);
                        setModal("details");
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                            const $modals = document.querySelectorAll('._modal-content');
                            $modals.forEach($modal => {
                                $modal.scrollTop = 0;
                            });
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }
    
    const handlePaymentRambo = async (e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);
        
        await axios.put(`${ endpointApi }rambos/${ rambo?.id }/payment`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${ jwt_access }`      
                        }
                    })
                    .then(({ data }) => {
                        dispatch(updateElementInList(data));
                        setRambo(data);
                        setModal("details");
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                            const $modals = document.querySelectorAll('._modal-content');
                            $modals.forEach($modal => {
                                $modal.scrollTop = 0;
                            });
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }
    
    const handleUpdateRambo = async (e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);
        
        await axios.put(`${ endpointApi }rambos/${ rambo?.id }`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${ jwt_access }`      
                        }
                    })
                    .then(({ data }) => {
                        dispatch(updateElementInList(data));
                        setRambo(data);
                        setModal("details");
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                            const $modals = document.querySelectorAll('._modal-content');
                            $modals.forEach($modal => {
                                $modal.scrollTop = 0;
                            });
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }

    return (
        <HelmetProvider>
            <Helmet>
                <title>Matières premières : Rambos - Société Mikalo</title>
            </Helmet>

            <div className='title d-flex justify-content-between'>
                <h1>Matières premières : Rambos</h1>
                <button type='button' className='btn btn-primary' onClick={ () => setModal("add") }><i className='fa fa-plus'></i> Ajouter</button>
            </div>

            <div ref={ addModal } className={ `_modal${ modal === 'add' ? ' active' : '' }` }>
                <div className='_modal-content'>
                    <div className='_modal-head'>
                        <h4>Enregistrement de matière première : Rambo</h4>
                        <button className='_modal-close' onClick={ () => {
                            setModal(null);
                        }}>&times;</button>
                    </div>
                    <div className='_modal-body'>
                        <form className='form' onSubmit={ handleAddRambo }>
                            <div className='mb-3'>
                                <label htmlFor='reception_date' className='required'>Date de réception</label>
                                <input type='date' id='reception_date' name='reception_date' className='form-control' value={ receptionDate } required onChange={ (e) => setReceptionDate(e.target.value) } onBlur={ () => setIsReceptionDateTouched(true) } />
                                { isReceptionDateTouched && receptionDate.length === 0 && <div className='form-error'>Veuillez sélectionner la date de réception.</div> }
                                { errors && errors.reception_date && <div className='form-error'>{ errors.reception_date[0] }</div> }
                            </div>
                            <div className='pb-3'>
                                <label htmlFor='supplier_id' className='required'>Nom du fournisseur</label>
                                <input type='hidden' name='supplier_id' value={ supplier ? supplier.id : '' } />
                                <SearchSupplier required={ true } updateSupplier={ setSupplier } defaultValue={ supplier } reset={ modal !== "add" } />
                                { errors && errors.supplier_id && <div className='form-error'>{ errors.supplier_id[0] }</div> }
                            </div>
                            <div className='mb-3'>
                                <label htmlFor='origin' className='required'>Origine</label>
                                <input type='text' id='origin' name='origin' className='form-control' placeholder='Origine' value={ origin } required onChange={ (e) => setOrigin(e.target.value) } onBlur={ () => setIsOriginTouched(true) } />
                                { isOriginTouched && origin.length === 0 && <div className='form-error'>Veuillez saisir l'origine de la matière première.</div> }
                                { isOriginTouched && origin.length > 0 && origin.length < 2 && <div className='form-error'>L'origine de la matière première est trop courte. Veuillez saisir au moins 2 caractères.</div> }
                                { errors && errors.origin && <div className='form-error'>{ errors.origin[0] }</div> }
                            </div>
                            <div className='mb-3'>
                                <label htmlFor='number_of_cartons' className='required'>Nombre de cartons</label>
                                <input type='number' min="0" step="1" id='number_of_cartons' name='number_of_cartons' className='form-control' placeholder='Nombre de cartons' value={ numberOfCartons } required onChange={ (e) => setNumberOfCartons(e.target.value) } onBlur={ () => setIsNumberOfCartonsTouched(true) } />
                                { isNumberOfCartonsTouched && numberOfCartons.length === 0 && <div className='form-error'>Veuillez saisir le nombre des cartons.</div> }
                                { errors && errors.number_of_cartons && <div className='form-error'>{ errors.number_of_cartons[0] }</div> }
                            </div>
                            <h6>Quantité reçue</h6>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <label htmlFor='received_quantity_short'>Quantité reçue (FOHY)</label>
                                    <input type='number' min="0" step="1" id='received_quantity_short' name='received_quantity_short' className='form-control' placeholder='Quantité reçue (FOHY)' value={ receivedQuantityShort } onChange={ (e) => setReceivedQuantityShort(e.target.value) } />
                                    { errors && errors.received_quantity_short && <div className='form-error'>{ errors.received_quantity_short[0] }</div> }
                                </div>
                                <div className='col-6 mb-3'>
                                    <label htmlFor='received_quantity_long'>Quantité reçue (LAVA)</label>
                                    <input type='number' min="0" step="1" id='received_quantity_long' name='received_quantity_long' className='form-control' placeholder='Quantité reçue (LAVA)' value={ receivedQuantityLong } onChange={ (e) => setReceivedQuantityLong(e.target.value) } />
                                    { errors && errors.received_quantity_long && <div className='form-error'>{ errors.received_quantity_long[0] }</div> }
                                </div>
                            </div>
                            <div className='mb-3'>
                                <label htmlFor='transport_cost' className='required'>Coût de transport</label>
                                <input type='number' min="0" step="0.01" id='transport_cost' name='transport_cost' className='form-control' placeholder='Coût de transport' value={ transportCost } required onChange={ (e) => setTransportCost(e.target.value) } onBlur={ () => setIsTransportCostTouched(true) } />
                                { isTransportCostTouched && transportCost.length === 0 && <div className='form-error'>Veuillez saisir le coût du transport.</div> }
                                { errors && errors.transport_cost && <div className='form-error'>{ errors.transport_cost[0] }</div> }
                            </div>
                            <div className='pt-2 text-center'>
                                <button type='submit' className='btn btn-lg btn-primary' disabled={
                                    receptionDate.length === 0 || origin.length < 2 || numberOfCartons.length === 0 || transportCost.length === 0 || supplier === null
                                }><i className="fa fa-save"></i> Enregistrer</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            
            <div ref={ verificationModal } className={ `_modal${ modal === 'verification' ? ' active' : '' }` }>
                <div className='_modal-content'>
                    { rambo &&
                    <div className='_modal-head'>
                        <h4>Vérification: Rambo { rambo.code }</h4>
                        <button className='_modal-close' onClick={ () => {
                            setModal(null);
                        }}>&times;</button>
                    </div> }
                    <div className='_modal-body'>
                        { rambo && <>
                            <h6 className='__title'>Informations à la réception</h6>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Date de réception</div>
                                    <div className='_value'>{ dateFormat(rambo.reception_date) }</div>
                                </div>
                                
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Code</div>
                                    <div className='_value'>{ rambo.code }</div>
                                </div>
                            </div>

                            <div className='row'>
                                { rambo.supplier &&
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Fournisseur</div>
                                    <div className='_value'>{ rambo.supplier.type === 'Company' ? rambo.supplier.company_name : rambo.supplier.last_name + ' ' + rambo.supplier.first_name }</div>
                                </div> }
                                
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Origine</div>
                                    <div className='_value'>{ rambo.origin }</div>
                                </div>
                            </div>
                            
                            <div className='mb-3'>
                                <div className='_label'>Nombre de cartons</div>
                                <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(rambo.number_of_cartons) }</div>
                            </div>
                            
                            <h6 className='__title'>Quantité reçue</h6>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>FOHY</div>
                                    <div className='_value'>{ rambo.received_quantity_short !== null ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(rambo.received_quantity_short) : '-'}</div>
                                </div>
                                
                                <div className='col-6 mb-3'>
                                    <div className='_label'>LAVA</div>
                                    <div className='_value'>{ rambo.received_quantity_long !== null ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(rambo.received_quantity_long) : '-' }</div>
                                </div>
                            </div>

                            <div className='mb-3'>
                                <div className='_label'>Coût de transport</div>
                                <div className='_value'>{ rambo.transport_cost !== null ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.transport_cost) + " Ariary" : '-' } </div>
                            </div>
                        </> }

                        <h6 className='__title'>2e vérification</h6>
                        <form className='form' onSubmit={ handleVerificationRambo }>
                            <h6># Quantité après comptage</h6>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <label htmlFor='received_after_counting_short' className='required'>FOHY</label>
                                    <input type='number' min="0" step="1" id='received_after_counting_short' name='received_after_counting_short' className='form-control' placeholder='FOHY' value={ receivedAfterCountingShort } required onChange={ (e) => setReceivedAfterCountingShort(e.target.value) } onBlur={ () => setIsReceivedAfterCountingShortTouched(true) } />
                                    { isReceivedAfterCountingShortTouched && receivedAfterCountingShort.length === 0 && <div className='form-error'>Veuillez saisir la quantité après comptage (FOHY).</div> }
                                    { errors && errors.received_after_counting_short && <div className='form-error'>{ errors.received_after_counting_short[0] }</div> }
                                </div>
                                <div className='col-6 mb-3'>
                                    <label htmlFor='received_after_counting_long' className='required'>LAVA</label>
                                    <input type='number' min="0" step="1" id='received_after_counting_long' name='received_after_counting_long' className='form-control' placeholder='LAVA' value={ receivedAfterCountingLong } required onChange={ (e) => setReceivedAfterCountingLong(e.target.value) } onBlur={ () => setIsReceivedAfterCountingLongTouched(true) } />
                                    { isReceivedAfterCountingLongTouched && receivedAfterCountingLong.length === 0 && <div className='form-error'>Veuillez saisir la quantité après comptage (LAVA).</div> }
                                    { errors && errors.received_after_counting_long && <div className='form-error'>{ errors.received_after_counting_long[0] }</div> }
                                </div>
                            </div>
                            <h6># Manquants</h6>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <label htmlFor='missing_quantity_short' className='required'>FOHY</label>
                                    <input type='number' min="0" step="1" id='missing_quantity_short' name='missing_quantity_short' className='form-control' placeholder='FOHY' value={ missingQuantityShort } required onChange={ (e) => setMissingQuantityShort(e.target.value) } onBlur={ () => setIsMissingQuantityShortTouched(true) } />
                                    { isMissingQuantityShortTouched && missingQuantityShort.length === 0 && <div className='form-error'>Veuillez saisir le nombre de manquants (FOHY).</div> }
                                    { errors && errors.missing_quantity_short && <div className='form-error'>{ errors.missing_quantity_short[0] }</div> }
                                </div>
                                <div className='col-6 mb-3'>
                                    <label htmlFor='missing_quantity_long' className='required'>LAVA</label>
                                    <input type='number' min="0" step="1" id='missing_quantity_long' name='missing_quantity_long' className='form-control' placeholder='LAVA' value={ missingQuantityLong } required onChange={ (e) => setMissingQuantityLong(e.target.value) } onBlur={ () => setIsMissingQuantityLongTouched(true) } />
                                    { isMissingQuantityLongTouched && missingQuantityLong.length === 0 && <div className='form-error'>Veuillez saisir le nombre de manquants (LAVA).</div> }
                                    { errors && errors.missing_quantity_long && <div className='form-error'>{ errors.missing_quantity_long[0] }</div> }
                                </div>
                            </div>
                            
                            <div className='pt-2 text-center'>
                                <button type='submit' className='btn btn-lg btn-primary' disabled={
                                    receivedAfterCountingShort.length === 0 || missingQuantityShort.length === 0 || receivedAfterCountingLong.length === 0 || missingQuantityLong.length === 0
                                }><i className="fa fa-save"></i> Enregistrer</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            
            <div ref={ paymentModal } className={ `_modal${ modal === 'payment' ? ' active' : '' }` }>
                <div className='_modal-content'>
                    { rambo &&
                    <div className='_modal-head'>
                        <h4>Infos de paiement: Rambo { rambo.code }</h4>
                        <button className='_modal-close' onClick={ () => {
                            setModal(null);
                        }}>&times;</button>
                    </div> }
                    <div className='_modal-body'>
                        { rambo && <>
                            <h6 className='__title'>Informations à la réception</h6>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Date de réception</div>
                                    <div className='_value'>{ dateFormat(rambo.reception_date) }</div>
                                </div>
                                
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Code</div>
                                    <div className='_value'>{ rambo.code }</div>
                                </div>
                            </div>

                            <div className='row'>
                                { rambo.supplier &&
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Fournisseur</div>
                                    <div className='_value'>{ rambo.supplier.type === 'Company' ? rambo.supplier.company_name : rambo.supplier.last_name + ' ' + rambo.supplier.first_name }</div>
                                </div> }
                                
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Origine</div>
                                    <div className='_value'>{ rambo.origin }</div>
                                </div>
                            </div>
                            
                            <div className='mb-3'>
                                <div className='_label'>Nombre de cartons</div>
                                <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(rambo.number_of_cartons) }</div>
                            </div>

                            <h6 className='__title'>Quantité reçue</h6>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>FOHY</div>
                                    <div className='_value'>{ rambo.received_quantity_short !== null ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(rambo.received_quantity_short) : '-' }</div>
                                </div>
                                
                                <div className='col-6 mb-3'>
                                    <div className='_label'>LAVA</div>
                                    <div className='_value'>{ rambo.received_quantity_long !== null ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(rambo.received_quantity_long) : '-' }</div>
                                </div>
                            </div>

                            <div className='mb-3'>
                                <div className='_label'>Coût de transport</div>
                                <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.transport_cost) } Ariary</div>
                            </div>

                            { rambo.received_after_counting_long &&
                            <>
                                <h6 className='__title'>2e vérification</h6>
                                <h6># Quantité après comptage</h6>
                                <div className='row'>
                                    <div className='col-6 mb-3'>
                                        <div className='_label'>FOHY</div>
                                        <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.received_after_counting_short) }</div>
                                    </div>
                                    <div className='col-6 mb-3'>
                                        <div className='_label'>LAVA</div>
                                        <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.received_after_counting_long) }</div>
                                    </div>
                                </div>
                                <h6># Manquants</h6>
                                <div className='row'>
                                    <div className='col-6 mb-3'>
                                        <div className='_label'>FOHY</div>
                                        <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.missing_quantity_short) }</div>
                                    </div>
                                    <div className='col-6 mb-3'>
                                        <div className='_label'>LAVA</div>
                                        <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.missing_quantity_long) }</div>
                                    </div>
                                </div>
                            </> }
                            
                            { rambo.received_after_counting_long &&
                            <>
                                <h6 className='__title'>Informations après triage</h6>
                                <h6># Quantité après triage</h6>
                                <div className='row'>
                                    <div className='col-6 mb-3'>
                                        <div className='_label'>FOHY</div>
                                        <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.quantity_after_sorting_short) }</div>
                                    </div>
                                    <div className='col-6 mb-3'>
                                        <div className='_label'>LAVA</div>
                                        <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.quantity_after_sorting_long) }</div>
                                    </div>
                                </div>
                                <h6># Déchets</h6>
                                <div className='row'>
                                    <div className='col-6 mb-3'>
                                        <div className='_label'>FOHY</div>
                                        <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.waste_after_sorting_short) }</div>
                                    </div>
                                    <div className='col-6 mb-3'>
                                        <div className='_label'>LAVA</div>
                                        <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.waste_after_sorting_long) }</div>
                                    </div>
                                </div>
                            </> }
                        </> }
                        
                        { rambo && (rambo.quantity_after_sorting_short || rambo.quantity_after_sorting_long) && <>
                            <h6 className='__title'>Informations de paiement</h6>
                            <form className='form' onSubmit={ handlePaymentRambo }>
                                <div className='mb-3'>
                                    <label htmlFor='unit_price' className='required'>Prix unitaire (en Ariary)</label>
                                    <input type='number' min="0" step="0.01" id='unit_price' name='unit_price' className='form-control' placeholder='Prix unitaire (en Ariary)' value={ unitPrice } required onChange={ (e) => setUnitPrice(e.target.value) } onBlur={ () => setIsUnitPriceTouched(true) } />
                                    { isUnitPriceTouched && unitPrice.length === 0 && <div className='form-error'>Veuillez saisir le prix unitaire.</div> }
                                    { errors && errors.unit_price && <div className='form-error'>{ errors.unit_price[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='remaining_amount' className='required'>Montant à payer (en Ariary)</label>
                                    <input type='number' min="0" step="0.01" id='remaining_amount' name='remaining_amount' className='form-control' placeholder='Montant à payer (en Ariary)' value={ remainingAmount } readOnly required onChange={ (e) => remainingAmount(e.target.value) } />
                                    { errors && errors.remaining_amount && <div className='form-error'>{ errors.remaining_amount[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='payment_method' className='required'>Méthode de paiement</label>
                                    <select id='payment_method' name='payment_method' className='form-control' value={ paymentMethod } required onChange={ (e) => setPaymentMethod(e.target.value) } onBlur={ () => setIsPaymentMethodTouched(true) }>
                                        <option value=''>Sélectionner</option>
                                        <option value="CASH">Espèce</option>
                                        <option value="CHEQUE">Chèque</option>
                                        <option value="BANK_TRANSFER">Virement bancaire</option>
                                        <option value="MVOLA">MVola</option>
                                        <option value="ORANGE_MONEY">Orange Money</option>
                                        <option value="AIRTEL_MONEY">Airtel Money</option>
                                        <option value="OTHER">Autre</option>
                                    </select>
                                    { isPaymentMethodTouched && paymentMethod.length === 0 && <div className='form-error'>Veuillez sélectionner la méthode de paiement.</div> }
                                    { errors && errors.payment_method && <div className='form-error'>{ errors.payment_method[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='payment_date' className='required'>Date de paiment</label>
                                    <input type='datetime-local' id='payment_date' name='payment_date' className='form-control' placeholder='Date de paiment' value={ paymentDate } required onChange={ (e) => setPaymentDate(e.target.value) } onBlur={ () => setIsPaymentDateTouched(true) } />
                                    { isPaymentDateTouched && paymentDate.length === 0 && <div className='form-error'>Veuillez sélectionner la date de paiement.</div> }
                                    { errors && errors.payment_date && <div className='form-error'>{ errors.payment_date[0] }</div> }
                                </div>

                                { paymentMethod !== 'CASH' &&
                                <>
                                    <div className='mb-3'>
                                        <label htmlFor='payment_account_number'>N° de compte</label>
                                        <input type='text' id='payment_account_number' name='payment_account_number' className='form-control' placeholder='N° de compte' value={ paymentAccountNumber } onChange={ (e) => setPaymentAccountNumber(e.target.value) } />
                                        { errors && errors.payment_account_number && <div className='form-error'>{ errors.payment_account_number[0] }</div> }
                                    </div>

                                    <div className='mb-3'>
                                        <label htmlFor='payment_reference'>Référence de paiement</label>
                                        <input type='text' id='payment_reference' name='payment_reference' className='form-control' placeholder='Référence de paiement' value={ paymentReference } onChange={ (e) => setPaymentReference(e.target.value) } />
                                        { errors && errors.payment_reference && <div className='form-error'>{ errors.payment_reference[0] }</div> }
                                    </div>
                                </> }
                                
                                <div className='pt-2 text-center'>
                                    <button type='submit' className='btn btn-lg btn-primary' disabled={
                                        unitPrice.length === 0 || remainingAmount.length === 0 || paymentMethod.length === 0 || paymentDate.length === 0
                                    }><i className="fa fa-save"></i> Enregistrer</button>
                                </div>
                            </form>
                        </> }
                    </div>
                </div>
            </div>

            <div ref={ updateModal } className={ `_modal${ modal === 'update' ? ' active' : '' }` }>
                <div className='_modal-content'>
                    { rambo && 
                    <div className='_modal-head'>
                        <h4>Rambo { rambo.code }</h4>
                        <button className='_modal-close' onClick={ () => {
                            setModal(null);
                        }}>&times;</button>
                    </div> }
                    <div className='_modal-body'>
                        { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                        <form className='form' onSubmit={ handleUpdateRambo }>
                            <h6>Informations à la réception</h6>
                            <div className='mb-3'>
                                <label htmlFor='code' className='required'>Code</label>
                                <input type='text' name='code' id="code" className='form-control' placeholder="Code" autoComplete='off' value={ code } onChange={ (e) => setCode(e.target.value) } onBlur={ () => setIsCodeTouched(true) } />
                                { isCodeTouched && code.length === 0 && <div className='form-error'>Veuillez saisir le code rambo.</div> }
                                { isCodeTouched && code.length > 0 && /^[A-Z]{2,5}_FRN\/\d{4}\/\d{4,}$/.test(code) === false && <div className='form-error'>Le code rambo n'est pas valide. Le format valide est XXXXX_FRN/[ANNEE]/[ORDRE].</div> }
                                { errors && errors.code && <div className='form-error'>{ errors.code[0] }</div> }
                            </div>
                            <div className='mb-3'>
                                <label htmlFor='_reception_date' className='required'>Date de réception</label>
                                <input type='date' id='_reception_date' name='reception_date' className='form-control' value={ receptionDate } required onChange={ (e) => setReceptionDate(e.target.value) } onBlur={ () => setIsReceptionDateTouched(true) } />
                                { isReceptionDateTouched && receptionDate.length === 0 && <div className='form-error'>Veuillez sélectionner la date de réception.</div> }
                                { errors && errors.reception_date && <div className='form-error'>{ errors.reception_date[0] }</div> }
                            </div>
                            <div className='pb-3'>
                                <label htmlFor='_supplier_id' className='required'>Nom du fournisseur</label>
                                <input type='hidden' name='supplier_id' value={ supplier ? supplier.id : '' } />
                                <SearchSupplier required={ true } id='_supplier_id' updateSupplier={ setSupplier } defaultValue={ supplier } reset={ modal !== "add" } />
                                { errors && errors.supplier_id && <div className='form-error'>{ errors.supplier_id[0] }</div> }
                            </div>
                            <div className='mb-3'>
                                <label htmlFor='_origin' className='required'>Origine</label>
                                <input type='text' id='_origin' name='origin' className='form-control' placeholder='Origine' value={ origin } required onChange={ (e) => setOrigin(e.target.value) } onBlur={ () => setIsOriginTouched(true) } />
                                { isOriginTouched && origin.length === 0 && <div className='form-error'>Veuillez saisir l'origine de la matière première.</div> }
                                { isOriginTouched && origin.length > 0 && origin.length < 2 && <div className='form-error'>L'origine de la matière première est trop courte. Veuillez saisir au moins 2 caractères.</div> }
                                { errors && errors.origin && <div className='form-error'>{ errors.origin[0] }</div> }
                            </div>
                            <div className='mb-3'>
                                <label htmlFor='_number_of_cartons' className='required'>Nombre de cartons</label>
                                <input type='number' min="0" step="1" id='_number_of_cartons' name='number_of_cartons' className='form-control' placeholder='Nombre de cartons' value={ numberOfCartons } required onChange={ (e) => setNumberOfCartons(e.target.value) } onBlur={ () => setIsNumberOfCartonsTouched(true) } />
                                { isNumberOfCartonsTouched && numberOfCartons.length === 0 && <div className='form-error'>Veuillez saisir le nombre des cartons.</div> }
                                { errors && errors.number_of_cartons && <div className='form-error'>{ errors.number_of_cartons[0] }</div> }
                            </div>
                            <h6>Quantité reçue</h6>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <label htmlFor='_received_quantity_short'>Quantité reçue (FOHY)</label>
                                    <input type='number' min="0" step="1" id='_received_quantity_short' name='received_quantity_short' className='form-control' placeholder='Quantité reçue (FOHY)' value={ receivedQuantityShort } onChange={ (e) => setReceivedQuantityShort(e.target.value) } />
                                    { errors && errors.received_quantity_short && <div className='form-error'>{ errors.received_quantity_short[0] }</div> }
                                </div>
                                <div className='col-6 mb-3'>
                                    <label htmlFor='_received_quantity_long'>Quantité reçue (LAVA)</label>
                                    <input type='number' min="0" step="1" id='_received_quantity_long' name='received_quantity_long' className='form-control' placeholder='Quantité reçue (LAVA)' value={ receivedQuantityLong } onChange={ (e) => setReceivedQuantityLong(e.target.value) } />
                                    { errors && errors.received_quantity_long && <div className='form-error'>{ errors.received_quantity_long[0] }</div> }
                                </div>
                            </div>
                            <div className='mb-3'>
                                <label htmlFor='_transport_cost' className='required'>Coût de transport</label>
                                <input type='number' min="0" step="0.01" id='_transport_cost' name='transport_cost' className='form-control' placeholder='Coût de transport' value={ transportCost } required onChange={ (e) => setTransportCost(e.target.value) } onBlur={ () => setIsTransportCostTouched(true) } />
                                { isTransportCostTouched && transportCost.length === 0 && <div className='form-error'>Veuillez saisir le coût du transport.</div> }
                                { errors && errors.transport_cost && <div className='form-error'>{ errors.transport_cost[0] }</div> }
                            </div>

                            { rambo && rambo.received_after_counting_long &&
                            <>
                                <h6>2e vérification</h6>
                                <div className='row'>
                                    <div className='col-6 mb-3'>
                                        <label htmlFor='_received_after_counting_short' className='required'>Quantité après comptage</label>
                                        <input type='number' min="0" step="1" id='_received_after_counting_short' name='received_after_counting_short' className='form-control' placeholder='Quantité après comptage' value={ receivedAfterCountingShort } required onChange={ (e) => setReceivedAfterCountingShort(e.target.value) } onBlur={ () => setIsReceivedAfterCountingShortTouched(true) } />
                                        { isReceivedAfterCountingShortTouched && receivedAfterCountingShort.length === 0 && <div className='form-error'>Veuillez saisir la quantité après comptage.</div> }
                                        { errors && errors.received_after_counting_short && <div className='form-error'>{ errors.received_after_counting_short[0] }</div> }
                                    </div>
                                    <div className='col-6 mb-3'>
                                        <label htmlFor='_received_after_counting' className='required'>Quantité après comptage</label>
                                        <input type='number' min="0" step="1" id='_received_after_counting' name='received_after_counting' className='form-control' placeholder='Quantité après comptage' value={ receivedAfterCountingLong } required onChange={ (e) => setReceivedAfterCountingLong(e.target.value) } onBlur={ () => setIsReceivedAfterCountingLongTouched(true) } />
                                        { isReceivedAfterCountingLongTouched && receivedAfterCountingLong.length === 0 && <div className='form-error'>Veuillez saisir la quantité après comptage.</div> }
                                        { errors && errors.received_after_counting && <div className='form-error'>{ errors.received_after_counting[0] }</div> }
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-6 mb-3'>
                                        <label htmlFor='_missing_quantity_short' className='required'>Manquants (FOHY)</label>
                                        <input type='number' min="0" step="1" id='_missing_quantity_short' name='missing_quantity_short' className='form-control' placeholder='Manquants (FOHY)' value={ missingQuantityShort } required onChange={ (e) => setMissingQuantityShort(e.target.value) } onBlur={ () => setIsMissingQuantityShortTouched(true) } />
                                        { isMissingQuantityShortTouched && missingQuantityShort.length === 0 && <div className='form-error'>Veuillez saisir le nombre de manquants (FOHY).</div> }
                                        { errors && errors.missing_quantity_short && <div className='form-error'>{ errors.missing_quantity_short[0] }</div> }
                                    </div>
                                    <div className='col-6 mb-3'>
                                        <label htmlFor='_missing_quantity_long' className='required'>Manquants (LAVA)</label>
                                        <input type='number' min="0" step="1" id='_missing_quantity_long' name='missing_quantity_long' className='form-control' placeholder='Manquants (LAVA)' value={ missingQuantityLong } required onChange={ (e) => setMissingQuantityLong(e.target.value) } onBlur={ () => setIsMissingQuantityLongTouched(true) } />
                                        { isMissingQuantityLongTouched && missingQuantityLong.length === 0 && <div className='form-error'>Veuillez saisir le nombre de manquants (LAVA).</div> }
                                        { errors && errors.missing_quantity_long && <div className='form-error'>{ errors.missing_quantity_long[0] }</div> }
                                    </div>
                                </div>
                            </> }
                            
                            { rambo && rambo.sorting_date !== null && rambo.quantity_after_sorting_long !== null && (rambo.quantity_after_sorting_short !== 0 || rambo.quantity_after_sorting_long !== 0) &&
                            <>
                                <h6>Informations après triage</h6>
                                <div className='mb-3'>
                                    <label htmlFor='_sorting_date' className='required'>Date de réception</label>
                                    <input type='date' id='_sorting_date' name='sorting_date' className='form-control' value={ sortingDate } required onChange={ (e) => setSortingDate(e.target.value) } onBlur={ () => setIsSortingDateTouched(true) } />
                                    { isSortingDateTouched && sortingDate.length === 0 && <div className='form-error'>Veuillez sélectionner la date de triage.</div> }
                                    { errors && errors.sorting_date && <div className='form-error'>{ errors.sorting_date[0] }</div> }
                                </div>
                                <h6>Quantité après triage</h6>
                                <div className='row'>
                                    <div className='col-6 mb-3'>
                                        <label htmlFor='_quantity_after_sorting_short' className='required'>FOHY</label>
                                        <input type='number' min="0" step="1" id='_quantity_after_sorting_short' name='quantity_after_sorting_short' className='form-control' placeholder='FOHY' value={ quantityAfterSortingShort } required onChange={ (e) => setQuantityAfterSortingShort(e.target.value) } onBlur={ () => setIsQuantityAfterSortingShortTouched(true) } />
                                        { isQuantityAfterSortingShortTouched && quantityAfterSortingShort.length === 0 && <div className='form-error'>Veuillez saisir la quantité après triage (FOHY).</div> }
                                        { errors && errors.quantity_after_sorting_short && <div className='form-error'>{ errors.quantity_after_sorting_short[0] }</div> }
                                    </div>
                                    <div className='col-6 mb-3'>
                                        <label htmlFor='_quantity_after_sorting_long' className='required'>LAVA</label>
                                        <input type='number' min="0" step="1" id='_quantity_after_sorting_long' name='quantity_after_sorting_long' className='form-control' placeholder='LAVA' value={ quantityAfterSortingLong } required onChange={ (e) => setQuantityAfterSortingLong(e.target.value) } onBlur={ () => setIsQuantityAfterSortingLongTouched(true) } />
                                        { isQuantityAfterSortingLongTouched && quantityAfterSortingLong.length === 0 && <div className='form-error'>Veuillez saisir la quantité après triage (LAVA).</div> }
                                        { errors && errors.quantity_after_sorting_long && <div className='form-error'>{ errors.quantity_after_sorting_long[0] }</div> }
                                    </div>
                                </div>
                                <h6>Nombre de déchets après triage</h6>
                                <div className='row'>
                                    <div className='col-6 mb-3'>
                                        <label htmlFor='_waste_after_sorting_short' className='required'>FOHY</label>
                                        <input type='number' min="0" step="1" id='_waste_after_sorting_short' name='waste_after_sorting_short' className='form-control' placeholder='FOHY' value={ wasteQuantityAfterSortingShort } required onChange={ (e) => setWasteQuantityAfterSortingShort(e.target.value) } onBlur={ () => setIsWasteQuantityAfterSortingShortTouched(true) } />
                                        { isWasteQuantityAfterSortingShortTouched && wasteQuantityAfterSortingShort.length === 0 && <div className='form-error'>Veuillez saisir le nombre de déchets après triage (FOHY).</div> }
                                        { errors && errors.waste_after_sorting_short && <div className='form-error'>{ errors.waste_after_sorting_short[0] }</div> }
                                    </div>
                                    <div className='col-6 mb-3'>
                                        <label htmlFor='_waste_after_sorting_long' className='required'>LAVA</label>
                                        <input type='number' min="0" step="1" id='_waste_after_sorting_long' name='waste_after_sorting_long' className='form-control' placeholder='LAVA' value={ wasteQuantityAfterSortingLong } required onChange={ (e) => setWasteQuantityAfterSortingLong(e.target.value) } onBlur={ () => setIsWasteQuantityAfterSortingLongTouched(true) } />
                                        { isWasteQuantityAfterSortingLongTouched && wasteQuantityAfterSortingLong.length === 0 && <div className='form-error'>Veuillez saisir le nombre de déchets après triage (LAVA).</div> }
                                        { errors && errors.waste_after_sorting_long && <div className='form-error'>{ errors.waste_after_sorting_long[0] }</div> }
                                    </div>
                                </div>
                            </> }

                            { rambo && rambo.quantity_after_sorting_long !== null && rambo.quantity_after_sorting_long !== 0 && <>
                                <h6>Informations de paiement</h6>
                                <div className='mb-3'>
                                    <label htmlFor='_unit_price' className='required'>Prix unitaire (en Ariary)</label>
                                    <input type='number' min="0" step="0.01" id='_unit_price' name='unit_price' className='form-control' placeholder='Prix unitaire (en Ariary)' value={ unitPrice } required onChange={ (e) => setUnitPrice(e.target.value) } onBlur={ () => setIsUnitPriceTouched(true) } />
                                    { isUnitPriceTouched && unitPrice.length === 0 && <div className='form-error'>Veuillez saisir le prix unitaire.</div> }
                                    { errors && errors.unit_price && <div className='form-error'>{ errors.unit_price[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='_remaining_amount' className='required'>Montant à payer (en Ariary)</label>
                                    <input type='number' min="0" step="0.01" id='_remaining_amount' name='remaining_amount' className='form-control' placeholder='Montant à payer (en Ariary)' value={ remainingAmount } readOnly required onChange={ (e) => remainingAmount(e.target.value) } />
                                    { errors && errors.remaining_amount && <div className='form-error'>{ errors.remaining_amount[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='_payment_method' className='required'>Méthode de paiement</label>
                                    <select id='_payment_method' name='payment_method' className='form-control' value={ paymentMethod } required onChange={ (e) => setPaymentMethod(e.target.value) } onBlur={ () => setIsPaymentMethodTouched(true) }>
                                        <option value=''>Sélectionner</option>
                                        <option value="CASH">Espèce</option>
                                        <option value="CHEQUE">Chèque</option>
                                        <option value="BANK_TRANSFER">Virement bancaire</option>
                                        <option value="MVOLA">MVola</option>
                                        <option value="ORANGE_MONEY">Orange Money</option>
                                        <option value="AIRTEL_MONEY">Airtel Money</option>
                                        <option value="OTHER">Autre</option>
                                    </select>
                                    { isPaymentMethodTouched && paymentMethod.length === 0 && <div className='form-error'>Veuillez sélectionner la méthode de paiement.</div> }
                                    { errors && errors.payment_method && <div className='form-error'>{ errors.payment_method[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='_payment_date' className='required'>Date de paiment</label>
                                    <input type='datetime-local' id='_payment_date' name='payment_date' className='form-control' placeholder='Date de paiment' value={ paymentDate } required onChange={ (e) => setPaymentDate(e.target.value) } onBlur={ () => setIsPaymentDateTouched(true) } />
                                    { isPaymentDateTouched && paymentDate.length === 0 && <div className='form-error'>Veuillez sélectionner la date de paiement.</div> }
                                    { errors && errors.payment_date && <div className='form-error'>{ errors.payment_date[0] }</div> }
                                </div>

                                { paymentMethod !== 'CASH' &&
                                <>
                                    <div className='mb-3'>
                                        <label htmlFor='_payment_account_number'>N° de compte</label>
                                        <input type='text' id='_payment_account_number' name='payment_account_number' className='form-control' placeholder='N° de compte' value={ paymentAccountNumber } onChange={ (e) => setPaymentAccountNumber(e.target.value) } />
                                        { errors && errors.payment_account_number && <div className='form-error'>{ errors.payment_account_number[0] }</div> }
                                    </div>

                                    <div className='mb-3'>
                                        <label htmlFor='_payment_reference'>Référence de paiement</label>
                                        <input type='text' id='_payment_reference' name='payment_reference' className='form-control' placeholder='Référence de paiement' value={ paymentReference } onChange={ (e) => setPaymentReference(e.target.value) } />
                                        { errors && errors.payment_reference && <div className='form-error'>{ errors.payment_reference[0] }</div> }
                                    </div>
                                </> }
                            </> }
                            <div className='pt-2 text-center'>
                                <button type='submit' className='btn btn-lg btn-primary'><i className="fa fa-save"></i> Enregistrer</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            
            <div ref={ detailsModal } className={ `_modal${ modal === 'details' ? ' active' : '' }` }>
                <div className='_modal-content'>
                    { rambo &&
                    <div className='_modal-head'>
                        <h4>Rambo { rambo.code }</h4>
                        <button className='_modal-close' onClick={ () => {
                            setModal(null);
                        }}>&times;</button>
                    </div> }
                    <div className='_modal-body'>
                    { rambo && <>
                        <h6 className='__title'>Informations à la réception</h6>
                        <div className='row'>
                            <div className='col-6 mb-3'>
                                <div className='_label'>Date de réception</div>
                                <div className='_value'>{ dateFormat(rambo.reception_date) }</div>
                            </div>
                            
                            <div className='col-6 mb-3'>
                                <div className='_label'>Code</div>
                                <div className='_value'>{ rambo.code }</div>
                            </div>
                        </div>

                        <div className='row'>
                            { rambo.supplier &&
                            <div className='col-6 mb-3'>
                                <div className='_label'>Fournisseur</div>
                                <div className='_value'>{ rambo.supplier.type === 'Company' ? rambo.supplier.company_name : rambo.supplier.last_name + ' ' + rambo.supplier.first_name }</div>
                            </div> }
                            
                            <div className='col-6 mb-3'>
                                <div className='_label'>Origine</div>
                                <div className='_value'>{ rambo.origin }</div>
                            </div>
                        </div>
                        
                        <div className='mb-3'>
                            <div className='_label'>Nombre de cartons</div>
                            <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(rambo.number_of_cartons) }</div>
                        </div>
                        
                        <h6 className='__title'>Quantité reçue</h6>
                        <div className='row'>
                            <div className='col-6 mb-3'>
                                <div className='_label'>FOHY</div>
                                <div className='_value'>{ rambo.received_quantity_short !== null ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(rambo.received_quantity_short) : '-' }</div>
                            </div>
                            
                            <div className='col-6 mb-3'>
                                <div className='_label'>LAVA</div>
                                <div className='_value'>{ rambo.received_quantity_long !== null ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(rambo.received_quantity_long) : '-' }</div>
                            </div>
                        </div>

                        <div className='mb-3'>
                            <div className='_label'>Coût de transport</div>
                            <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.transport_cost) } Ariary</div>
                        </div>

                        { rambo.received_after_counting_long &&
                        <>
                            <h6 className='__title'>2e vérification</h6>
                            <h6># Quantité après comptage</h6>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>FOHY</div>
                                    <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.received_after_counting_short) }</div>
                                </div>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>LAVA</div>
                                    <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.received_after_counting_long) }</div>
                                </div>
                            </div>
                            <h6># Manquants</h6>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>FOHY</div>
                                    <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.missing_quantity_short) }</div>
                                </div>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>LAVA</div>
                                    <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.missing_quantity_long) }</div>
                                </div>
                            </div>
                        </> }
                        
                        { (rambo.quantity_after_sorting_long || rambo.quantity_after_sorting_short) &&
                        <>
                            <h6 className='__title'>Infos après triage</h6>
                            <div className='row'>
                                <div className='col-12 mb-3'>
                                    <div className='_label'>Date de triage</div>
                                    <div className='_value'>{ rambo.sorting_date !== null ? dateFormat(rambo.sorting_date) :  '-' }</div>
                                </div>
                                <h6 className='col-12'>Quantité après triage</h6>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>FOHY</div>
                                    <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.quantity_after_sorting_short) }</div>
                                </div>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>LAVA</div>
                                    <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.quantity_after_sorting_long) }</div>
                                </div>
                                <h6 className='col-12'>Déchets après triage</h6>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>FOHY</div>
                                    <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.waste_after_sorting_short) }</div>
                                </div>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>LAVA</div>
                                    <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.waste_after_sorting_long) }</div>
                                </div>
                            </div>
                        </> }

                        { rambo.payment_method && <>
                            <h6 className='__title'>Informations de paiement</h6>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Prix unitaire</div>
                                    <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.unit_price) } Ariary</div>
                                </div>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Montant à payer</div>
                                    <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(rambo.remaining_amount) } Ariary</div>
                                </div>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Méthode de paiement</div>
                                    <div className='_value'>{ rambo.payment_method === 'CASH' ? 'Espèce' : (rambo.payment_method === 'CHEQUE' ? 'Chèque' : (rambo.payment_method === 'BANK_TRANSFER' ? 'Virement bancaire' : (rambo.payment_method === 'MVOLA' ? 'Mvola' : (rambo.payment_method === 'ORANGE_MONEY' ? 'Orange Money' : (rambo.payment_method === 'AIRTEL_MONEY' ? 'Airtel Money' : 'Autre'))))) }</div>
                                </div>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Date de paiement</div>
                                    <div className='_value'>{ dateFormat(rambo.payment_date, "short", true) }</div>
                                </div>
                                { rambo.payment_method !== 'CASH' && <>
                                    <div className='col-6 mb-3'>
                                        <div className='_label'>Numéro de compte</div>
                                        <div className='_value'>{ rambo.payment_account_number ?? '-'  }</div>
                                    </div>
                                    <div className='col-6 mb-3'>
                                        <div className='_label'>Référence de paiement</div>
                                        <div className='_value'>{ rambo.payment_reference ?? '-' }</div>
                                    </div>
                                </> }
                            </div>
                        </> }
                        { rambo.cutting_date && <>
                            <h6 className='__title'>Infos coupe</h6>
                            <div className='mb-3'>
                                <div className='_label'>Date de coupe</div>
                                <div className='_value'>{ rambo.cutting_date !== null ? dateFormat(rambo.cutting_date) :  '-' }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Nombre de coupe obtenus</div>
                                <div className='_value'>{ rambo.number_of_cuts_obtained !== null ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(rambo.number_of_cuts_obtained) :  '-' }</div>
                            </div>
                            <h6 className='__title'>Infos après triage coupe</h6>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Quantité après coupe</div>
                                    <div className='_value'>{ rambo.quantity_after_cutting !== null ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(rambo.quantity_after_cutting) :  '-' }</div>
                                </div>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Nombre de déchets</div>
                                    <div className='_value'>{ rambo.waste_quantity_after_cutting !== null ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(rambo.waste_quantity_after_cutting) :  '-' }</div>
                                </div>
                            </div>
                        </> }
                        { rambo.cleaning_date && <>
                            <h6 className='__title'>Infos après nettoyage</h6>
                            <div className='row'>
                                <div className='col-12 mb-3'>
                                    <div className='_label'>Date de nettoyage</div>
                                    <div className='_value'>{ rambo.cleaning_date !== null ? dateFormat(rambo.cleaning_date) :  '-' }</div>
                                </div>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Quantité après nettoyage</div>
                                    <div className='_value'>{ rambo.quantity_after_cleaning !== null ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(rambo.quantity_after_cleaning) :  '-' }</div>
                                </div>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Nombre de déchets</div>
                                    <div className='_value'>{ rambo.waste_quantity_after_cleaning !== null ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(rambo.waste_quantity_after_cleaning) :  '-' }</div>
                                </div>
                            </div>
                        </> }
                        { rambo.quantity_after_final_inspection && <>
                            <h6 className='__title'>Infos après vérification finale</h6>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Quantité après la vérification finale</div>
                                    <div className='_value'>{ rambo.quantity_after_final_inspection !== null ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(rambo.quantity_after_final_inspection) :  '-' }</div>
                                </div>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Nombre de déchets</div>
                                    <div className='_value'>{ rambo.waste_quantity_after_final_inspection !== null ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(rambo.waste_quantity_after_final_inspection) :  '-' }</div>
                                </div>
                            </div>
                        </> }
                        { rambo.description && <>
                            <h6 className='__title'>Description</h6>
                            <div className='col-6 mb-3'>
                                <div className='_label'>Description</div>
                                <div className='_value'>{ rambo.description ?? '-' }</div>
                            </div>
                        </> }
                    </> }
                    </div>
                </div>
            </div>

            <div className='box'>
                <table className='table table-striped'>
                    <thead>
                        <tr style={{ verticalAlign: 'middle' }}>
                            <th width="160" rowSpan={ 2 }>Date de réception</th>
                            <th width="200" rowSpan={ 2 }>Code</th>
                            <th className="text-center" colSpan={ 2 }>Quantité reçue</th>
                            <th className="text-center" colSpan={ 2 }>Quantité après comptage</th>
                            <th className="text-center" colSpan={ 2 }>Nombre de manquant</th>
                            <th className="text-center" colSpan={ 2 }>Quantité après triage</th>
                            <th width="75" className="text-end" rowSpan={ 2 }>Actions</th>
                        </tr>
                        <tr style={{ verticalAlign: 'middle' }}>
                            <th className='text-center'>FOHY</th>
                            <th className='text-center'>LAVA</th>
                            <th className='text-center'>FOHY</th>
                            <th className='text-center'>LAVA</th>
                            <th className='text-center'>FOHY</th>
                            <th className='text-center'>LAVA</th>
                            <th className='text-center'>FOHY</th>
                            <th className='text-center'>LAVA</th>
                        </tr>
                    </thead>
                    <tbody>
                    { rambos.loading && <tr><td colSpan={ 11 }>Chargement...</td></tr> }
                    { rambos.loading === false && rambos.data && rambos.data.total === 0 && <tr><td colSpan={ 11 }>Aucun élément trouvé</td></tr> }
                    { rambos.loading === false && rambos.data && rambos.data.data && rambos.data.data.map((item, index) => {
                        return (
                        <tr key={ index }>
                            <td>{ dateFormat(item.reception_date) }</td>
                            <td>{ item.code }</td>
                            <td className="text-center">{ item.received_quantity_short !== null ? new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 0 , maximumFractionDigits: 0}).format(item.received_quantity_short) : '-' }</td>
                            <td className="text-center">{ item.received_quantity_long !== null ? new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 0 , maximumFractionDigits: 0}).format(item.received_quantity_long) : '-' }</td>
                            <td className="text-center">{ item.received_after_counting_short !== null ? new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 0 , maximumFractionDigits: 0}).format(item.received_after_counting_short) : '-' }</td>
                            <td className="text-center">{ item.received_after_counting_long !== null ? new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 0 , maximumFractionDigits: 0}).format(item.received_after_counting_long) : '-' }</td>
                            <td className="text-center">{ item.missing_quantity_short !== null ? new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 0 , maximumFractionDigits: 0}).format(item.missing_quantity_short) : '-' }</td>
                            <td className="text-center">{ item.missing_quantity_long !== null ? new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 0 , maximumFractionDigits: 0}).format(item.missing_quantity_long) : '-' }</td>
                            <td className="text-center">{ item.quantity_after_sorting_short !== null ? new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 0 , maximumFractionDigits: 0}).format(item.quantity_after_sorting_short) : '-' }</td>
                            <td className="text-center">{ item.quantity_after_sorting_long !== null ? new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 0 , maximumFractionDigits: 0}).format(item.quantity_after_sorting_long) : '-' }</td>
                            <td className="text-end">
                                <div className='actions'>
                                    <button type='button' className='toggle-action' onClick={ (e) => {
                                        e.stopPropagation();
                                        setActionModal(actionModal !== item.id ? item.id : null);
                                    } }><i className='fa fa-ellipsis-v'></i></button>
                                    <ul className={ actionModal === item.id ? 'active' : '' }>
                                        <li><button type='button' onClick={ () => {
                                            setActionModal(null);
                                            setRambo(item);
                                            setModal("details");
                                        } }><i className="fa fa-eye"></i> Voir les détails</button></li>
                                        
                                        { item.received_after_counting_long === null &&
                                        <li><button type='button' onClick={ () => {
                                            setActionModal(null);
                                            setRambo(item);
                                            setModal("verification");
                                        } }><i className="fa fa-check-circle"></i> 2e vérification</button></li> }
                                        
                                        { item.quantity_after_sorting_long !== null && item.payment_method === null &&
                                        <li><button type='button' onClick={ () => {
                                            setActionModal(null);
                                            setRambo(item);
                                            setModal("payment");
                                        } }><i className="fa fa-credit-card"></i> Infos de paiement</button></li> }
                                        
                                        <li><button type='button' onClick={ () => {
                                            setActionModal(null);
                                            setRambo(item);
                                            setModal("update");
                                        } }><i className="fa fa-edit"></i> Modifier</button></li>
                                    </ul>
                                </div>
                            </td>
                        </tr> ) })}
                    </tbody>
                </table>
            </div>
            
            { rambos && rambos.data &&
            <Paginate currentPage={ rambos.data.current_page } totalPages={ rambos.data.last_page } pathname={ location.pathname } search={ location.search } /> }
        </HelmetProvider>
    )
}
